import React, { useEffect, useState } from 'react';
import { Container, Button, Card, Form, Row, Col, Table, Spinner, Badge, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { FaUser, FaPhone, FaMapMarkerAlt, FaCity, FaGlobe, FaEnvelope, FaTrash, FaPlus } from 'react-icons/fa';
import Footer from './layouts/Footer';
import { CountryCodes } from './layouts/CountryCodes';
import { CountriesISO } from './layouts/CountriesISO';
import { getReservaPorConfirmationId, actualizarPerfilHuesped, CreateProfile, UpdateReservation } from '../utils/Api';
import { UpdateProfileRequest } from '../classes/UpdateProfileRequest';
//import MainProfileDetails from '../classes/MainProfileDetails';
import { ProfileDetails } from '../classes/ProfileDetails';
import ReservationDetails from '../classes/ReservationDetails';

const countryCodes = CountryCodes;
const countriesISO = CountriesISO;

const FormularioCheckInExpress = () => {
  const [formData, setFormData] = useState({
    email: '',
    nameFirst: '',
    nameSur: '',
    phoneNumber: '',
    address1: '',
    address2: '',
    city: '',
    countryCode: '',
    codigoPostal: '',
    taxType: '',
    hotelId: '',
    reservationId: '',
    profileId: '',
    rut: '',
    identificationType: '3',  //3 = RUT, 5 = Pasaporte
    Language: "ES",
  });
  
  const [reservaData, setReservaData] = useState(null);
  const [accompanyingPersons, setAccompanyingPersons] = useState([]);
  const [errors, setErrors] = useState({});
  const { businessUnit: unitParam, confirmationId } = useParams();
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [clienteId, setClienteId] = useState(null); // Nuevo estado para almacenar el idCliente
  const handleRemoveGuest = (idCliente) => {
    if (!reservaData?.accompanyGuests) return;

    const updatedGuests = reservaData.accompanyGuests.filter(
      (guest) => guest.idCliente !== idCliente
    );

    setReservaData((prevData) => {
      const newData = {
        ...prevData,
        accompanyGuests: updatedGuests,
      };

      console.log("Actualizando estado:", newData);
      return newData;
    });
  };

  // Mapa de unidad → base URL (ajusta a tus endpoints reales)
const UNIT_BASE_MAP = {
  PEBEBRO: process.env.REACT_APP_API_BASE_URL_PEBEBRO || "https://interfaz-pbx:4455/api",
  CHLPBCH:    process.env.REACT_APP_API_BASE_URL_PBCH    || "https://interfaz-pbx:4455/api",
};

  // Normaliza la unidad a las claves que usa tu Config.js
const normalizeUnit = (u) => {
  if (!u) return 'CHLPBCH';
  const t = String(u).toUpperCase();
  if (t === 'HEBRO' || t === 'PEBEBRO') return 'PEBEBRO';
  if (t === 'BLU' || t === 'CHLPBCH' || t === 'RADISSON' || t === 'RADISSONBLU') return 'CHLPBCH';
  return 'CHLPBCH';
};

useEffect(() => {
  // 1) Normaliza y guarda unidad
  const unit = normalizeUnit(unitParam);
  localStorage.setItem("businessUnit", unit);

  // 2) Resuelve y guarda base URL en localStorage
  const apiBaseUrl = UNIT_BASE_MAP[unit] || UNIT_BASE_MAP.PBCH;
  localStorage.setItem("apiBaseUrl", apiBaseUrl);

  // 3) (Opcional) guarda el confirmationId si lo usas en otras pantallas
  if (confirmationId) {
    localStorage.setItem("confirmationId", confirmationId);
  }

  // 4) Carga la reserva ahora que ya está seteada la base en localStorage
  const fetchData = async () => {
    try {
      const data = await getReservaPorConfirmationId(confirmationId);
      setReservaData(data);
      populateForm(data);
    } catch (err) {
      console.error("Error al obtener la reserva:", err);
      setError("No se pudo cargar la reserva.");
    }
  };

  if (confirmationId) fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [unitParam, confirmationId]);

// Guarda unidad e id de confirmación y luego carga la reserva
// useEffect(() => {
//   const unit = normalizeUnit(unitParam);
//   const saved = localStorage.getItem('businessUnit');
//   if (saved !== unit) localStorage.setItem('businessUnit', unit);

//   // 2) Resuelve y guarda base URL en localStorage
//   const apiBaseUrl = UNIT_BASE_MAP[unit] || UNIT_BASE_MAP.PBCH;
//   localStorage.setItem("apiBaseUrl", apiBaseUrl);

//   if (confirmationId) {
//     localStorage.setItem('confirmationId', confirmationId);
//   }

//   // Si aquí no tienes la carga, llama tu fetch:
//   // fetchData();  // o el nombre de tu función que hace getReservaPorConfirmationId
// }, [unitParam, confirmationId]);


//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const data = await getReservaPorConfirmationId(confirmationId);
//         setReservaData(data); // Guarda los datos completos de la reserva
//         setClienteId(data.cliente.idCliente); // Almacena el idCliente aquí
//         populateForm(data); // Rellena el formulario con los datos del cliente
//       } catch (error) {
//         console.error('Error al obtener la reserva:', error);
//       }
//     };

//     if (confirmationId) {
//       fetchData();
//     }
//   }, [confirmationId]);

  // Función para rellenar el formulario con los datos del cliente
  const populateForm = (data) => {
    setFormData({
      email: data.cliente.email || '',
      nameFirst: data.cliente.nombres || '',
      nameSur: data.cliente.apellidoPaterno || '',
      phoneNumber: data.cliente.telefono || '',
      address1: data.cliente.direccion || '',
      address2: data.cliente.comuna || '',
      city: data.cliente.ciudad || '',
      countryCode: data.cliente.pais || '',
      codigoPostal: data.cliente.codigoPostal || '',
      taxType: data.taxTypeType?.Code || '',
      hotelId: data.hotelId || '',
      reservationId: data.reserva?.idReserva || '',
      profileId: data.cliente?.idProfile || '',
      rut: data.cliente?.rut || '',
      identificationType: data.cliente?.identificationType || '3',
      Language: data.cliente?.language || 'ES',
      fechaNacimiento: data.cliente?.fechaNacimiento || '',
      currencyCode: data.cliente?.currencyCode || 'CLP',
    });
  };

  // Validaciones de campos
  const validate = () => {
    const newErrors = {};
    if (!formData.nameFirst) newErrors.nameFirst = 'Este campo es obligatorio';
    if (!formData.email) newErrors.email = 'Este campo es obligatorio';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email no válido';
    if (!formData.phoneNumber) newErrors.phoneNumber = 'Este campo es obligatorio';
    if (!formData.address1) newErrors.address1 = 'Este campo es obligatorio';
    if (!formData.city) newErrors.city = 'Este campo es obligatorio';
    if (!formData.countryCode) newErrors.countryCode = 'Este campo es obligatorio';
    //if (!formData.codigoPostal) newErrors.codigoPostal = 'Este campo es obligatorio';
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAccompanyingChange = (index, e) => {
    const { name, value } = e.target;
    const updatedAccompanying = [...accompanyingPersons];
    updatedAccompanying[index][name] = value;
    setAccompanyingPersons(updatedAccompanying);
  };

  const handleAddAccompanying = () => {
    setAccompanyingPersons([...accompanyingPersons, { nombre: '', apellido: '' }]);
  };

  const handleRemoveAccompanying = (index) => {
    const updatedAccompanying = accompanyingPersons.filter((_, i) => i !== index);
    setAccompanyingPersons(updatedAccompanying);
  };

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault();

      // const errs = validate();
      // if (Object.keys(errs).length) {
      //   setErrors(errs);
      //   return;
      // }
      // setErrors({});
    }
      setIsLoading(true);
      setError(null);
      console.log(formData);
  
    try {
        // Actualizar datos del cliente principal
        const mainProfileResponse = await actualizarPerfilHuesped(
            formData,
            reservaData.cliente.idCliente
        );
        console.log("Cliente principal actualizado:", mainProfileResponse);

        // Obtener los ID de los acompañantes actuales en la reserva
        const existingGuests = Array.isArray(reservaData?.accompanyGuests)
        ? reservaData.accompanyGuests.map(guest => guest.idCliente)
        : [];

        // Si no hay acompañantes nuevos ni existentes, actualizar la reserva con una lista vacía
        if (accompanyingPersons.length === 0 && existingGuests.length === 0) {
            console.log("No hay acompañantes, actualizando reserva sin acompañantes.");
            const _hotelId = localStorage.getItem('businessUnit') || 'CHLPBCH';
            const reservationResponse = await UpdateReservation(
                _hotelId,
                reservaData.reserva.idReserva,
                new ReservationDetails(
                  reservaData.reserva.idReserva,
                    reservaData.cliente.idCliente,
                    [] // Lista vacía de acompañantes
                )
            );

            setReservaData((prevData) => ({
                ...prevData,
                accompanyGuests: [] // Vaciar la lista de acompañantes en el estado
            }));

            alert("Actualización completada con éxito ✅");
            setIsLoading(false);
            return;
        }

        // Crear perfiles de acompañantes nuevos (los que no tienen idCliente)
        let accompanyingProfiles = [];
        if (accompanyingPersons.length > 0) {
            accompanyingProfiles = await Promise.all(
                accompanyingPersons
                    .filter(person => !person.idCliente) // Solo los nuevos
                    .map(async (person) => {
                        const profileDetails = new ProfileDetails(person, formData);
                        const response = await CreateProfile({ profileDetails });
                        return response; // ID del nuevo perfil
                    })
            );
        }

        console.log("Perfiles creados:", accompanyingProfiles);

        // Definir todos los perfiles de la reserva (cliente principal + acompañantes)
        const allProfiles = [
          reservaData.cliente.idCliente,
            ...existingGuests,
            ...accompanyingProfiles
        ];

        console.log("Todos los perfiles antes de eliminar duplicados:", allProfiles);

        // Eliminar duplicados asegurando que todos sean strings
        const uniqueProfiles = [...new Set(allProfiles.map(profile => String(profile)))];

        console.log("Perfiles únicos después de eliminar duplicados:", uniqueProfiles);

        // Construir detalles de la reserva
        const reservationDetails = new ReservationDetails(
          reservaData.reserva.idReserva,
            reservaData.cliente.idCliente,
            uniqueProfiles.slice(1) // Acompañantes sin incluir el cliente principal
        );

        console.log("Detalles de la reserva a actualizar:", JSON.stringify(reservationDetails, null, 2));

        // Enviar la actualización de la reserva
        const _hotelId = localStorage.getItem('businessUnit') || 'CHLPBCH';
        const reservationResponse = await UpdateReservation(
            _hotelId,
            reservaData.reserva.idReserva,
            reservationDetails
        );

        console.log("Reserva actualizada con éxito:", reservationResponse);

        // Actualizar estado local con los nuevos acompañantes
        const updatedGuests = [
            ...(Array.isArray(reservaData?.accompanyGuests)
                ? reservaData.accompanyGuests.filter(guest =>
                    uniqueProfiles.includes(String(guest.idCliente))
                  )
                : []),
            ...accompanyingPersons
                .filter(person => !existingGuests.includes(person.idCliente)) // Solo nuevos
                .map((person, index) => ({
                    ...person,
                    idCliente: accompanyingProfiles[index] // Asignar nuevo ID
                }))
        ];

        setReservaData((prevData) => ({
            ...prevData,
            accompanyGuests: updatedGuests.length > 0 ? updatedGuests : [] // Vaciar si no hay acompañantes
        }));

        alert("Actualización completada con éxito ✅");
    } catch (error) {
        setError(error.message);
        console.error("Error en el proceso:", error);
        alert("Ocurrió un error durante el proceso de actualización ⚠️");
    } finally {
        setIsLoading(false);
    }
};

return (
  <Container className="py-4">
    <Card className="shadow-sm mb-4">
      <Card.Header className="bg-primary text-white">
        <h2 className="mb-0">Check-In Express</h2>
        <small className="d-block">Número de confirmación: {confirmationId}</small>
      </Card.Header>
      
      <Card.Body>
        <Table striped bordered hover className="mb-4">
          <thead className="table-dark">
            <tr>
              <th>Fecha de Llegada</th>
              <th>Fecha de Salida</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Badge bg="success" className="fs-6">
                  {reservaData?.reserva?.fechaCheckIn
                    ? new Intl.DateTimeFormat('es-CL').format(new Date(reservaData.reserva.fechaCheckIn))
                    : 'N/A'}
                </Badge>
              </td>
              <td>
                <Badge bg="danger" className="fs-6">
                  {reservaData?.reserva?.fechaCheckOut
                    ? new Intl.DateTimeFormat('es-CL').format(new Date(reservaData.reserva.fechaCheckOut))
                    : 'N/A'}
                </Badge>
              </td>              
            </tr>
          </tbody>
        </Table>

        <Card className="mb-4">
          <Card.Header className="bg-light">
            <h4 className="mb-0">Información del Huésped Principal</h4>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="formIdentification">
                    <Form.Label className="fw-bold">Identificación</Form.Label>

                    <div className="d-flex align-items-center gap-4 mb-2">
                      <Form.Check
                        inline
                        type="radio"
                        id="idTypeRut"
                        name="identificationType"
                        label="RUT"
                        value="3"
                        checked={String(formData.identificationType) === '3'}
                        onChange={handleChange}
                      />
                      <Form.Check
                        inline
                        type="radio"
                        id="idTypePassport"
                        name="identificationType"
                        label="Pasaporte"
                        value="5"
                        checked={String(formData.identificationType) === '5'}
                        onChange={handleChange}
                      />
                    </div>

                    <Form.Control
                      type="text"
                      name="rut"
                      value={formData.rut || ''}
                      onChange={handleChange}
                      placeholder={String(formData.identificationType) === '3'
                        ? '12345678-9'
                        : 'Número de pasaporte'}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <Form.Group controlId="formEmail">
                    <Form.Label><FaEnvelope className="me-2" />Actualizar Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={formData.email || ''}
                      onChange={handleChange}
                      isInvalid={!!errors.email}
                      className="py-2"
                    />
                    <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formNameFirst">
                    <Form.Label className="fw-bold">Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      name="nameFirst"
                      value={formData.nameFirst}
                      onChange={handleChange}
                      isInvalid={!!errors.nameFirst}
                      readOnly
                      lassName="py-2"
                    />
                  </Form.Group>                  
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formNameSur">
                    <Form.Label className="fw-bold">Apellido</Form.Label>
                    <Form.Control
                      type="text"
                      name="nameSur"
                      value={formData.nameSur}
                      onChange={handleChange}
                      isInvalid={!!errors.nameSur}
                      readOnly
                      lassName="py-2"
                    />
                  </Form.Group>                 
                </Col>
              </Row>

              <Row className="mb-3">
                
                <Col md={3}>
                  <Form.Group controlId="formTelefono">
                    <Form.Label><FaPhone className="me-2" />Teléfono</Form.Label>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleChange}
                      isInvalid={!!errors.phoneNumber}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group controlId="formDireccion">
                    <Form.Label><FaMapMarkerAlt className="me-2" />Dirección</Form.Label>
                    <Form.Control
                      type="text"
                      name="address1"
                      value={formData.address1 || ''}
                      onChange={handleChange}
                      isInvalid={!!errors.address1}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>
                
                <Col md={3}>
                  <Form.Group controlId="formDireccion2">
                    <Form.Label><FaMapMarkerAlt className="me-2" />Estado o Comuna</Form.Label>
                    <Form.Control
                      type="text"
                      name="address2"
                      value={formData.address2 || ''}
                      onChange={handleChange}
                      isInvalid={!!errors.address2}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>

              </Row>
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formPais">
                    <Form.Label className="fw-bold">País</Form.Label>
                    <Form.Select
                      name="countryCode"
                      value={formData.countryCode || 'CL'}
                      onChange={handleChange}
                    >
                      {countriesISO.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name} ({country.code})
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formCiudad">
                    <Form.Label><FaCity className="me-2" />Ciudad</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      isInvalid={!!errors.city}
                      className="py-2"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-bold">Moneda</Form.Label>
                    <Form.Select
                      name="currencyCode"
                      value={formData.currencyCode || "CLP"}
                      onChange={handleChange}
                    >
                      <option value="CLP">CLP</option>
                      <option value="USD">USD</option>
                      <option value="EUR">EUR</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formLanguage">
                    <Form.Label className="fw-bold">Idioma</Form.Label>
                    <Form.Select
                      name="Language"
                      value={formData.Language || 'ES'}
                      onChange={handleChange}
                    >
                      <option value="ES">Español</option>
                      <option value="EN">Inglés</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Header className="bg-light d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Acompañantes</h4>
            <Button variant="outline-primary" size="sm" onClick={handleAddAccompanying}>
              <FaPlus className="me-1" /> Añadir Acompañante
            </Button>
          </Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              {/* <thead className="table-light">
                <tr>
                  <th>ID Perfil</th>
                  <th>Nombre</th>
                  <th>Apellido</th>
                  <th>Acciones</th>
                </tr>
              </thead> */}
              <tbody>
                {Array.isArray(reservaData?.accompanyGuests) && reservaData.accompanyGuests.map((guest) => (
                  <tr key={guest.idCliente}>
                    <td>{guest.idCliente}</td>
                    <td>{guest.nombre}</td>
                    <td>{guest.apellido}</td>
                    <td>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleRemoveGuest(guest.idCliente)}
                      >
                        <FaTrash />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            {accompanyingPersons.map((person, index) => (
              <Card key={index} className="mb-3">
                <Card.Body>
                  <Row>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                          type="text"
                          name="nombre"
                          value={person.nombre}
                          onChange={(e) => handleAccompanyingChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control
                          type="text"
                          name="apellido"
                          value={person.apellido}
                          onChange={(e) => handleAccompanyingChange(index, e)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                          type="text"
                          name="phonenumber"
                          value={person.phonenumber}
                          onChange={(e) => handleAccompanyingChange(index, e)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className="d-flex align-items-end">
                      <Button
                        variant="outline-danger"
                        onClick={() => handleRemoveAccompanying(index)}
                        className="w-100"
                      >
                        <FaTrash />
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            ))}
          </Card.Body>
        </Card>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">Actualización completada con éxito!</Alert>}

        <div className="d-flex justify-content-end">
          <Button
            variant="primary"
            size="lg"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Spinner as="span" animation="border" size="sm" className="me-2" />
                Guardando...
              </>
            ) : 'Guardar Cambios'}
          </Button>
        </div>
      </Card.Body>
    </Card>
    <Footer />
  </Container>
);
};

export default FormularioCheckInExpress;